import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationService } from './navigation.service';
import { PreferencesLogicService } from '../preferences/logic/preferences/preferences-logic.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [NavigationService, PreferencesLogicService],
})
export class NavigationModule {}
